import { BeatLoader } from "react-spinners";

export default function SmallLoader() {
  return (
    <div className="loaderContainer">
      <BeatLoader size={10} color="#0C2658" />
    </div>
  );
}
